import { useDropzone } from "react-dropzone";
import { DropzoneContainer } from "./styles";

export interface IProps {
    onDrop?: any;
}

export default function NewFileInputDrop(props: IProps) {
    const applicationTypes = ["application/xml", "application/pdf", "text/xml"];

    const { acceptedFiles, getRootProps, getInputProps, isDragAccept, isDragActive } = useDropzone({
        accept: applicationTypes,
        onDrop: props.onDrop,
        multiple: false,
    });

    const borderColor = () => {
        if (isDragActive) {
            return isDragAccept ? "#0D6400" : "#9D0000";
        }
        return "#C2C2C2";
    };

    const textColor = () => {
        if (isDragActive) {
            return isDragAccept ? "#0D6400" : "#9D0000";
        }
        return "#606060";
    };

    const displayText = () => {
        if ((isDragActive && acceptedFiles.length === 1) || isDragActive) {
            return isDragAccept
                ? "Arquivo no formato válido!"
                : "Arquivo no formato inválido ou múltiplos arquivos selecionados!";
        }
        if (acceptedFiles.length === 1) {
            return `${acceptedFiles[0].name} - ${acceptedFiles[0].size} bytes`;
        }

        return "Clique ou arraste o arquivo aqui! XML ou PDF";
    };

    return (
        <DropzoneContainer $borderColor={borderColor()} $textColor={textColor()}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "100%",
                    height: 200,
                }}
                {...getRootProps()}
            >
                <input {...getInputProps({ type: "file" })} />
                <p style={{ paddingTop: "8%" }}>{displayText()}</p>
            </div>
        </DropzoneContainer>
    );
}
